var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 224.727294921875 214.32150268554688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-process-icon-1",
    opacity: 1,
    x: 60,
    y: 60,
    width: 104.727294921875,
    height: 94.32150268554688
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-process-icon2",
    filterUnits: "userSpaceOnUse",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadow-1-feOffset-shadow",
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadow-1-feOffset-shadow",
    result: "shadow-1-feGaussianBlur-shadow",
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadow-1-feGaussianBlur-shadow",
    result: "shadow-1-feColorMatrix-shadow",
    type: "matrix",
    values: "0 0 0 0 0  0 0 0 0 0.7333333333333333  0 0 0 0 1  0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path-process-icon-3",
    opacity: 1,
    fillRule: "evenodd",
    d: "M117.6007080078125,101.92092895507812 L143.7813720703125,101.92092895507812 L154.2578125,112.39828491210938 L70.47412109375,112.39828491210938 L80.9459228515625,101.91860961914062 L107.12890625,101.91860961914062 L107.12890625,91.43896484375 L96.6571044921875,80.95932006835938 L96.6571044921875,70.47964477539062 L107.12890625,60 L117.6007080078125,60 L128.072509765625,70.47964477539062 L128.072509765625,80.96160888671875 L117.6007080078125,91.4412841796875 L117.6007080078125,101.92092895507812 L117.598388671875,70.47964477539062 L107.1265869140625,70.47964477539062 L107.1265869140625,80.95928955078125 L117.598388671875,80.95928955078125 L117.598388671875,70.47964477539062 L117.6007080078125,101.92092895507812Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-process-icon-4",
    opacity: 1,
    fillRule: "evenodd",
    d: "M70.4718017578125,122.88253784179688 L80.9459228515625,122.88253784179688 L91.4154052734375,133.3621826171875 L91.4154052734375,143.84185791015625 L80.943603515625,154.32150268554688 L70.4718017578125,154.32150268554688 L60,143.84185791015625 L60,133.3621826171875 L70.4718017578125,122.88253784179688 L70.4718017578125,143.84414672851562 L80.9459228515625,143.84414672851562 L80.943603515625,133.364501953125 L70.4718017578125,133.364501953125 L70.4718017578125,143.84414672851562 L70.4718017578125,122.88253784179688Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-process-icon-5",
    opacity: 1,
    fillRule: "evenodd",
    d: "M107.12890625,122.88253784179688 L117.6007080078125,122.88253784179688 L128.072509765625,133.3621826171875 L128.072509765625,143.84185791015625 L117.6007080078125,154.32150268554688 L107.12890625,154.32150268554688 L96.6571044921875,143.84185791015625 L96.6571044921875,133.3621826171875 L107.12890625,122.88253784179688 L107.12890625,143.84414672851562 L117.6007080078125,143.84414672851562 L117.6007080078125,133.364501953125 L107.12890625,133.364501953125 L107.12890625,143.84414672851562 L107.12890625,122.88253784179688Z"
  }), "-\n    ", /*#__PURE__*/React.createElement("path", {
    id: "path-process-icon-6",
    opacity: 1,
    fillRule: "evenodd",
    d: "M143.78369140625,122.88253784179688 L154.2554931640625,122.88253784179688 L164.727294921875,133.3621826171875 L164.727294921875,143.84185791015625 L154.2554931640625,154.32150268554688 L143.78369140625,154.32150268554688 L133.3118896484375,143.84185791015625 L133.3118896484375,133.3621826171875 L143.78369140625,122.88253784179688 L143.78369140625,143.84414672851562 L154.2554931640625,143.84414672851562 L154.2554931640625,133.364501953125 L143.78369140625,133.364501953125 L143.78369140625,143.84414672851562 L143.78369140625,122.88253784179688Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect-process-icon-7",
    opacity: 1,
    x: 70.47180185318257,
    y: 112.40288673789553,
    width: 10.471810386311102,
    height: 10.479654858749422,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-process-icon-8",
    x1: 0.18181999999999998,
    y1: 0.63636,
    x2: 0.18181999999999998,
    y2: 0.54546
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(0,77,255)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.649,
    stopColor: "rgb(0,120,255)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "rgb(0,168,255)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(0,186,255)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "rect-process-icon-9",
    opacity: 1,
    x: 107.12659424830372,
    y: 112.40288673789553,
    width: 10.471810386311022,
    height: 10.479654858749422,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-process-icon-10",
    x1: 0.5,
    y1: 0.63636,
    x2: 0.5,
    y2: 0.54546
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(0,77,255)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.649,
    stopColor: "rgb(0,120,255)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "rgb(0,168,255)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(0,186,255)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "rect-process-icon-11",
    opacity: 1,
    x: 143.7813866434226,
    y: 112.40288673789553,
    width: 10.471810386311157,
    height: 10.479654858749422,
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-process-icon-12",
    x1: 0.81818,
    y1: 0.63636,
    x2: 0.81818,
    y2: 0.54546
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(0,77,255)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.649,
    stopColor: "rgb(0,120,255)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "rgb(0,168,255)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(0,186,255)",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-process-icon-1",
    fill: "black",
    filter: "url(#filter-process-icon2)",
    stroke: "black",
    strokeOpacity: 0,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-process-icon-3",
    fill: "rgb(0,186,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-process-icon-4",
    fill: "rgb(0,186,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-process-icon-5",
    fill: "rgb(0,186,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-process-icon-6",
    fill: "rgb(0,186,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-process-icon-7",
    fill: "url(#linearGradient-process-icon-8)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-process-icon-9",
    fill: "url(#linearGradient-process-icon-10)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-process-icon-11",
    fill: "url(#linearGradient-process-icon-12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess);
export default __webpack_public_path__ + "static/media/process.91759bebb183ded40298086d876b950b.svg";
export { ForwardRef as ReactComponent };